export const OK = 'OK';
export const UN_AUTHENTICATE = 'UN_AUTHENTICATE';
export const OFFLINE = 'OFFLINE';
export default { OK, UN_AUTHENTICATE, OFFLINE };
